export default __webpack_public_path__ + "static/media/1783.02f003fb.png";